export function toThousandFilter(num) {
  let a = Number(num) || ''
  if (a) {
    return a.toString().replace(/^-?\d+/g, m => m.replace(/(\d{1,3})(?=(\d{3})+$)/g, '$1,'))
  }
  return num
}

// 将数组转为字符串，去除无效值
export function combiningStrings(value, separator=', ') {
  if (Object.prototype.toString.call(value) !== '[object Array]') return ''
  value = value.filter(x => !!x)
  return value.join(separator)
}

export function formatPhone(phone) {
  // phone --string
  const num = (phone || '').replace(/[^\d]/g, '')
  const c = num
      .match(/(\d{3})?(\d{3})?(\d{4})?(\d*)/i)
      .slice(1)
      .filter(v => v)
      .slice(0, 3)
  return c[0] ? c[0] + (c[1] ? '-' + c[1] + (c[2] ? '-' + c[2] : '') : '') : ''
}

export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}
export function callFormatPhone(phone, isIntercept) {
  let numberStr = `${phone}`.replace(/[^\d]/g, '')
  if (numberStr.length > 10 && isIntercept) {
    numberStr = numberStr.slice(numberStr.length - 10)
  }
  const [step1, step2, step3] = [numberStr.slice(0, 3), numberStr.slice(3, 6), numberStr.slice(6, 10)]
  return step1 + (step2 ? `-${step2}` + (step3 ? `-${step3}` : '') : '')
}
export function formatExpirationDate(value) {
  if (/\/$/g.test(value)) {
    return value[0]
  }
  value = value.trim()
  let c = value.replace(/[^\d]/g, '')
    .match(/(\d{1})?(\d{1})?(\d{2,4})?(\d*)/i)
    .slice(1)
    .filter(v => v)
    .slice(0, 3)
  return c[0] ? (c[1] ? c[0] + c[1] + ' / ' + (c[2] ? c[2] : '') : c[0]) : ''
}

export const emailRex = "^[\\.a-zA-Z0-9_-]+(\\+[a-zA-Z0-9_+-]+)?@[a-zA-Z0-9_-]+(\\.[a-zA-Z]{2,36}){1,10}$"

// downloadByBlob
export function downloadByBlob(url, fileName, type) {
  if (!url) {
    return;
  }
  let axios = new XMLHttpRequest();
  axios.open("GET", url, true);
  axios.setRequestHeader("Cache-Control", "no-cache");
  axios.setRequestHeader("Access-Control-Allow-Origin", "*");
  axios.responseType = "blob";
  axios.onload = (e) => {
    let res = e.target.response;
    let blob = new Blob([res]);
    let aLink = document.createElement("a");
    aLink.download = fileName + "." + type;
    aLink.href = URL.createObjectURL(blob);
    aLink.click();
  };
  axios.send();
}

export function exportBySearch(urlStr = '') {
  let theRequest = {};
  if (urlStr.indexOf("?") !== -1) {
    let str = urlStr.substr(1);
    let strs = str.split("&");
    for (let i = 0; i < strs.length; i++) {
      theRequest[strs[i].split("=")[0]] = decodeURIComponent(strs[i].split("=")[1] || '');
    }
  }
  return theRequest
}

